import clsx from 'clsx';
import Link from 'next/link';

import type { NavbarItem } from '../types';

interface BasicGroupElementProps {
  item: NavbarItem;
  setMobileMenuOpen: (open: boolean) => void;
}

export function BasicGroupElement(props: BasicGroupElementProps) {
  const { item, setMobileMenuOpen } = props;

  if (item.type === 'button' && 'smallAction' in item) {
    return item.smallAction(item.name, setMobileMenuOpen, item.icon);
  }

  // Do not show hide on mobile items
  if (item.hideOnMobile) {
    return null;
  }

  return (
    <Link
      href={'href' in item ? item.href : '#'}
      target={'blank' in item ? '_blank' : undefined}
      key={item.name}
      onClick={() => setMobileMenuOpen(false)}
      className={clsx(
        'group -mx-3 flex items-center gap-x-6 rounded-lg p-3 text-base/7 font-semibold text-neutral-900 hover:bg-neutral-50',
        item.className,
      )}
    >
      {item.icon && (
        <div className="flex size-11 flex-none items-center justify-center rounded-lg bg-neutral-50 group-hover:bg-white">
          <item.icon className="size-5 flex-none text-neutral-400" />
        </div>
      )}
      {item.name}
    </Link>
  );
}
